module.exports = __webpack_public_path__ + "media/images/flags/1x1/cmr-abe6890d262219fda12cabed1682c2b3.svg";